
import { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

class ConfirmModal extends Component {

    constructor(props) {
        super(props);
        this.id = props.id
        this.state = {
            open: false,
        };
    }

    handleConfirm = () => {
        // Execute the confirm action
        if (this.props.onConfirm) {
          this.props.onConfirm();
        }
      };

      handleClose = () => {
        // Execute the confirm action
        if (this.props.onConfirm) {
          this.props.onCancel();
        }
      };

    render() {

        const { open, handleClose, buttonText, confirmType, children } = this.props;


        return (
            <div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="confirmation-dialog"
                    aria-describedby="confirm-action"
                >
                    <DialogTitle id="confirmation-dialog">{`Are you sure you would like to ${confirmType}?` || 'Are you sure?'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="confirm-action">{children}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleConfirm} color="primary">
                            {buttonText || 'Confirm'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

        )
    }
}

export default ConfirmModal
